import React from 'react';
import BaseAssignmentModal from './BaseAssignmentModal';
import useEntertainment from '../../hooks/useEntertainment';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';

const EntertainmentAssignmentModal = ({
  open,
  onClose,
  onAssign,
  loading,
  assignedEntertainment = null,
}) => {
  const { getEntertainments } = useEntertainment();

  return (
    <BaseAssignmentModal
      open={open}
      onClose={onClose}
      onAssign={onAssign}
      loading={loading}
      assignedItems={assignedEntertainment ? [assignedEntertainment] : []}
      fetchItems={() => getEntertainments(true)}
      title='Entertainment zuweisen'
      itemNameKey='longName'
      singleSelect={true}
      icon={SportsEsportsIcon}
    />
  );
};

export default EntertainmentAssignmentModal;
